import h from "trader-hyperscript";
import { rpc } from "trader.ts/network";
import { renderDeleteButton } from "../../client/savebutton";
import * as routes from "../../routes";

export function render(opts: {}): HTMLElement | HTMLElement[] {
  return (
    <div style="text-align: right">
      {renderDeleteButton({
        label: "Verwijder alle afwezigheden uit de lijst",
        confirmationLabel: "Ben je zeker dat je deze allemaal wilt verwijderen?",
        doDelete: function (): Promise<unknown> {
          return rpc(routes.clearAbsencesToApproveListSpec, undefined, {});
        },
        redirectTo: routes.absences_to_approve_listRoute.link(),
      })}
    </div>
  );
}
